import SeoMetaData from "common/SeoMetaData"
import ErrorLoadingAiPage from "components/CreateAi/ErrorLoadingAiPage"

const ErrorAi = () => {
  const seo = {
    title: "יצירת תמונה ב-AI|error",
    description: "חדש! יצירת תמונה של מקדונלד׳ס בהתאמה אישית",
    keywords: "יצירת תמונה ב-AI",
  }

  return (
    <>
      <SeoMetaData data={seo} />

      <ErrorLoadingAiPage />
    </>
  )
}

export default ErrorAi
